if (typeof QuickAddToCart !== 'function') {

  class QuickAddToCart extends HTMLElement {
    constructor() {
      super()
      this.locationPromise = null
      this.productForm = this.querySelector('product-form')
      this.variantSelector = this.querySelector('variant-selector')
      this.defaultAddToCartText = this.getAttribute('data-add-to-cart-text')
      this.defaultOutOfStockText = this.getAttribute('data-out-of-stock-text')
      if (this.productForm) {
        this.addToCart = this.productForm.querySelector('[type="submit"]')
        this.addToCartText = this.addToCart.querySelector('.button__text')
        this.storeSelector = document.querySelector('store-selector[data-main-selector]')
        this.init()
      }
    }

    async init() {
      this.productForm.addEventListener('add-to-cart', () => {
        if (!document.body.classList.contains('template-cart')) {
          document.getElementById('site-cart-sidebar')?.show?.()
        }
        if (document.getElementById('cart-recommendations')) {
          document.getElementById('cart-recommendations').generateRecommendations()
        }
        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          const total = document.querySelector('#AjaxCartForm [data-cart-total]')
          if (total) elm.textContent = total.textContent
        })
        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          const count = document.querySelector('#AjaxCartForm [data-cart-count]')
          if (count) elm.textContent = count.textContent
        })
      })

      if (this.storeSelector) {
        this.storeSelector.addEventListener('storechanged', this.onStoreChanged.bind(this))
      }

      this.addEventListener('variant-selector:changed', this.onVariantChanged.bind(this))

      // Liquid provides the immediate online state. Refine store inventory
      // only for cards near the viewport or when a shopper interacts.
      this.refreshAvailability()

      const requestInventory = () => this.ensureLocation()
      this.addEventListener('pointerenter', requestInventory, { once: true, passive: true })
      this.addEventListener('focusin', requestInventory, { once: true })

      if ('IntersectionObserver' in window) {
        this.inventoryObserver = new IntersectionObserver((entries, observer) => {
          if (!entries[0]?.isIntersecting) return
          observer.unobserve(this)
          this.ensureLocation()
        }, { rootMargin: '400px 0px' })
        this.inventoryObserver.observe(this)
      } else {
        this.ensureLocation()
      }
    }

    async ensureLocation() {
      if (!this.locationPromise) this.locationPromise = this.getLocation()
      await this.locationPromise.catch(() => false)
      this.refreshAvailability()
      return this.locationPromise
    }

    refreshAvailability() {
		this.getVariantData()
		this.updateUnavailableVariants()
		this.selectFirstAvailableVariant()
		this.syncVariantPresentation()
		this.checkAddToCart()
    }

    async getLocation() {
      try {
        const token = window.KROWN.settings.storefront_api_key;
        const domain = window.KROWN.settings.store_domain;
        const productId = this.getAttribute('data-origin-id') || this.getAttribute('data-product-id');
		if ( !productId ) return false;

		const storefrontProductId = String(productId).startsWith('gid://shopify/Product/')
			? String(productId)
			: `gid://shopify/Product/${productId}`;
            
			  const query = `#graphql
                query Product($id: ID!) {
                    product(id: $id) {
                        availableForSale
                        id
                        title
                        totalInventory
                        variants(first: 250) {
                            nodes {
                                components(first: 50) {
                                  nodes {
                                    productVariant{
                                      id
                                      quantityAvailable
                                      storeAvailability (first: 250) {
                                        nodes {
                                          available
                                          location {
                                            id
                                            name
                                          }
                                          quantityAvailable
                                        }
                                      }
                                    }
                                    quantity
                                  }
                                }
                                id
                                title
                                availableForSale
                                currentlyNotInStock
                                quantityAvailable
                                storeAvailability (first: 250) {
                                    nodes {
                                      available
                                        location {
                                            id
                                            name
                                        }
                                        quantityAvailable
                   
                                    }
                                }
                            }
                        }
                    }
                }
            `
       
            const data = await window.ShopSanteInventory.load({
              productId: storefrontProductId,
              domain,
              token,
              query,
            })

			if (!data?.data?.product) return false;
        this.locationProduct = data   
		return true;

      } catch (error) {
		return false;
      }
    }

    getStoreName() {
      const selectedHandle = localStorage.getItem('selected-store')
      if (!selectedHandle) return 'Shop Santé Inc.'

      const selectedItem = [...document.querySelectorAll('.store-selector-item[data-handle]')]
        .find(item => item.getAttribute('data-handle') === selectedHandle)
      const selectedTitle = selectedItem?.getAttribute('data-title')
      if (selectedTitle) return selectedTitle

      const handleize = value => String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
      const names = new Set()

      ;(this.locationProduct?.data?.product?.variants?.nodes || []).forEach(variant => {
        ;(variant?.storeAvailability?.nodes || []).forEach(node => {
          if (node?.location?.name) names.add(node.location.name)
        })
        ;(variant?.components?.nodes || []).forEach(component => {
          ;(component?.productVariant?.storeAvailability?.nodes || []).forEach(node => {
            if (node?.location?.name) names.add(node.location.name)
          })
        })
      })

      return [...names].find(name => handleize(name) === selectedHandle)
        || 'Shop Santé Inc.'
    }

    isLinkedBundle() {
      return Boolean(this.getAttribute('data-origin-id'))
    }

    getLinkedBundleQuantity() {
      const configuredQuantity = Number(this.getAttribute('data-quantity-each-bundle') || 0)
      if (configuredQuantity > 0) return configuredQuantity

      const title = this.closest('product-page, quick-buy')?.querySelector('h1, h2, [data-js-product-title]')?.textContent
        || document.title
      const titleQuantity = Number(String(title || '').match(/(\d+)\s*[x×]/i)?.[1] || 1)
      return Math.max(1, titleQuantity)
    }

    getOriginInventoryPolicy(item) {
      const policyScript = this.querySelector('[data-js-origin-variant-inventory-policy]')
        || this.closest('product-page')?.querySelector('[data-js-origin-variant-inventory-policy]')
      if (!policyScript || !item) return 'deny'

      try {
        const policies = JSON.parse(policyScript.textContent || '[]')
        if (policies.length === 1) return policies[0]?.inventory || 'deny'
        return policies.find(policy =>
          this.normalizeVariantTitle(policy.title) === this.normalizeVariantTitle(item.title)
        )?.inventory || 'deny'
      } catch (error) {
        return 'deny'
      }
    }

    getLinkedBundleState(item, storeName) {
      if (!item) return { available: false, quantity: 0, isBundle: true }

      if (this.getOriginInventoryPolicy(item) === 'continue' || item.currentlyNotInStock) {
        return { available: true, quantity: 9999, isBundle: true }
      }

      const unitQuantity = Math.max(0, Number(item?.quantityAvailable || 0))
      const quantity = Math.floor(unitQuantity / this.getLinkedBundleQuantity())

      return {
        available: quantity > 0,
        quantity,
        isBundle: true
      }
    }

    normalizeVariantTitle(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('fr-CA')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
    }

    findLocationVariant(localVariant, locationVariants = this.locationProduct?.data?.product?.variants?.nodes || []) {
      if (!localVariant) return null
      if (this.isLinkedBundle() && locationVariants.length === 1) return locationVariants[0]
      if (!this.isLinkedBundle()) {
        return locationVariants.find(item =>
          Number(item.id.split('gid://shopify/ProductVariant/')[1]) === Number(localVariant.id)
        ) || null
      }

      const localTitles = [localVariant.title, localVariant.public_title, ...(localVariant.options || [])]
        .map(title => this.normalizeVariantTitle(title))
        .filter(Boolean)
      return locationVariants.find(item =>
        localTitles.includes(this.normalizeVariantTitle(item.title))
      ) || null
    }

    getLocationState(item, storeName, inventoryPolicy) {
      const components = item?.components?.nodes || []

      if (components.length) {
        const states = components.map(component => {
          const requiredQuantity = Math.max(1, Number(component?.quantity || 1))
          const isOnline = storeName === 'Shop Santé Inc.'
          const availability = component?.productVariant?.storeAvailability?.nodes?.find(
            node => node?.location?.name === storeName
          )
          const quantityAvailable = Math.max(0, Number(
            isOnline
              ? availability?.quantityAvailable ?? component?.productVariant?.quantityAvailable ?? 0
              : availability?.quantityAvailable || 0
          ))

          return {
            available: (isOnline || Boolean(availability?.available)) && quantityAvailable >= requiredQuantity,
            quantity: Math.floor(quantityAvailable / requiredQuantity)
          }
        })

        return {
          available: states.length === components.length && states.every(state => state.available),
          quantity: states.length ? Math.min(...states.map(state => state.quantity)) : 0,
          isBundle: true
        }
      }

      const availability = item?.storeAvailability?.nodes?.find(
        node => node?.location?.name === storeName
      )
      const isOnline = storeName === 'Shop Santé Inc.'
      const quantity = Math.max(0, Number(
        isOnline
          ? availability?.quantityAvailable ?? item?.quantityAvailable ?? 0
          : availability?.quantityAvailable || 0
      ))

      return {
        available: isOnline
          ? inventoryPolicy === 'continue' || quantity > 0
          : Boolean(availability?.available) && quantity > 0,
        quantity,
        isBundle: false
      }
    }

    getVariantData() {
      const variantId = this.getAttribute('data-variant-id')
      const variantJson = this.querySelector(
        'script[type="application/json"]:not([data-js-origin-variant-inventory-policy])'
      )
	  if ( !variantJson ) {
		this.variantData = []
		this.currentVariant = null
		return false
	  }

	  let arrayVariants
	  try {
		arrayVariants = JSON.parse(variantJson.textContent)
	  } catch (error) {
		arrayVariants = []
	  }

	  if ( !this.locationProduct?.data?.product ) {
            this.variantData = this.isLinkedBundle()
	          ? arrayVariants.map(variant => ({
	              ...variant,
              // A linked variant explicitly configured to continue selling is
              // safe to expose even if the Storefront inventory request is
              // temporarily unavailable. Deny-policy bundles remain blocked.
	              available: Boolean(variant.available)
	                || this.getOriginInventoryPolicy(variant) === 'continue'
            }))
          : arrayVariants
		this.currentVariant = this.variantData.find((v) => v.id === Number(variantId)) || null
		return false
	  }

	  const arrayVariantsLocation = this.locationProduct.data
      const variantIds = new Map()
      const storeName = this.getStoreName()

      
      if (this.isLinkedBundle()) {
        const locationVariants = arrayVariantsLocation.product.variants.nodes
        const requiredQuantity = this.getLinkedBundleQuantity()
        const allOriginVariantsAvailable = locationVariants.length === arrayVariants.length
          && locationVariants.every(item => item.currentlyNotInStock
            || Math.floor(Math.max(0, Number(item.quantityAvailable || 0)) / requiredQuantity) > 0)
        arrayVariants.forEach(variant => {
          const item = this.findLocationVariant(variant, locationVariants)
          const state = item
            ? this.getLinkedBundleState(item, storeName)
            : { available: allOriginVariantsAvailable, quantity: 0, isBundle: true }
          variantIds.set(
            Number(variant.id),
            item ? state.available : allOriginVariantsAvailable
          )
        })
      }
      else {
        arrayVariantsLocation.product.variants.nodes.forEach((item) => {
          const parsedId = item.id.split('gid://shopify/ProductVariant/')[1]
          const variantElement = item.title === 'Default Title' ? this : this.variantSelector?.querySelector(`.variant-selector__dropdown ul > li[data-variant-id="${parsedId}"]`)
          if(!variantElement) return

          const inventory_policy = variantElement.getAttribute('data-inventory-policy')
          const state = this.getLocationState(item, storeName, inventory_policy)
          variantIds.set(Number(parsedId), state.available)
        })
      }

      arrayVariants = arrayVariants.map(v => {
        if (variantIds.has(v.id)) {
          v.available = variantIds.get(v.id)
        }
        return v
      })

      this.variantData = arrayVariants
	  this.currentVariant = this.variantData.find((v) => v.id === Number(variantId)) || null
	  return true
    }

    async onVariantChanged(event) {
      await this.ensureLocation()
      const { id } = event.detail
      this.setAttribute('data-variant-id', id)
      this.currentVariant = this.variantData.find((v) => v.id === Number(id))
      this.getStoreName()
      this.syncVariantPresentation()
      this.checkAddToCart()
    }

    async onStoreChanged() {
	  if (!this.locationPromise) return
	  await this.locationPromise.catch(() => false)
      this.refreshAvailability()
    }

    updateUnavailableVariants() {
      if (this.variantSelector) {
        const items = this.variantSelector.querySelectorAll('[data-variant-id]')
        items.forEach(item => {
          const variantId = Number(item.getAttribute('data-variant-id'))
          const variant = this.variantData.find((v) => v.id === variantId)
          if (variant && variant.available) {
            item.classList.remove('disabled')
            item.hidden = false
            item.removeAttribute('aria-hidden')
            item.removeAttribute('aria-disabled')
          }
          else {
            item.classList.add('disabled')
            item.hidden = false
            item.removeAttribute('aria-hidden')
            item.setAttribute('aria-disabled', 'true')
          }
        })
      }
    }

    selectFirstAvailableVariant() {
      if (this.currentVariant?.available) return

      const firstAvailable = this.variantData?.find(variant => variant.available)
      if (!firstAvailable) return

      this.currentVariant = firstAvailable
      this.setAttribute('data-variant-id', String(firstAvailable.id))

      const input = this.querySelector('variant-selector [name="id"]')
      if (input) input.value = String(firstAvailable.id)

      const item = this.variantSelector?.querySelector(`[data-variant-id="${firstAvailable.id}"]`)
      if (item) {
        this.variantSelector.querySelectorAll('[data-variant-id]').forEach(option => option.classList.remove('selected'))
        item.classList.add('selected')
        const title = this.variantSelector.querySelector('summary [data-variant-title]')
        const label = this.variantSelector.querySelector('summary [data-variant-label]')
        if (title) title.textContent = item.getAttribute('data-variant-title') || ''
        if (label) label.textContent = item.getAttribute('data-variant-label') || ''
      }

      this.dispatchEvent(new CustomEvent('variant-selector:changed', {
        bubbles: true,
        detail: { id: firstAvailable.id }
      }))
    }

    syncVariantPresentation() {
      if (!this.currentVariant) return

      const card = this.closest('.product-item')
      if (!card) return

      const featuredImage = this.currentVariant.featured_image
        || this.currentVariant.featured_media?.preview_image
      const imageUrl = featuredImage?.src

      if (imageUrl) {
        const primaryImage = card.querySelector(
          '[data-js-replace="image"] .product-item__image-figure--primary img, [data-js-replace="image"] img'
        )
        if (primaryImage) {
          primaryImage.src = imageUrl
          primaryImage.removeAttribute('srcset')
          primaryImage.alt = featuredImage.alt
            || card.querySelector('.product-item__title')?.textContent?.trim()
            || ''
        }
      }

      card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        try {
          const url = new URL(link.href, window.location.origin)
          url.searchParams.set('variant', String(this.currentVariant.id))
          link.href = `${url.pathname}${url.search}${url.hash}`
        } catch (error) {
          // A malformed third-party link must never break variant selection.
        }
      })
    }

    checkAddToCart() {
      if (!this.currentVariant || !this.currentVariant.available) {
        if (this.addToCart) this.addToCart.disabled = true
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultOutOfStockText
            || window.KROWN.settings.locales.products_sold_out_variant
        }
      } else {
        if (this.addToCart) this.addToCart.disabled = false
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultAddToCartText
            || window.KROWN.settings.locales.products_add_to_cart_button
        }
      }
    }
  }

  if (typeof customElements.get('quick-add-to-cart') == 'undefined') {
    customElements.define('quick-add-to-cart', QuickAddToCart)
  }

}

if (typeof QuickViewProduct !== 'function') {

  class QuickViewProduct extends HTMLElement {
    constructor() {
      super()
      if (this.querySelector('a')) {
        this.init()
      }
    }
    init() {

      this.quickViewModal = null
      this.querySelector('a').addEventListener('click', (e) => {

        e.preventDefault()

        if (!this.quickViewModal) {

          const target = e.currentTarget

          target.classList.add('working')

          fetch(`${target.getAttribute('href')}${target.getAttribute('href').includes('?') ? '&' : '?'}view=quick-view`)
            .then(response => {
              if (!response.ok) throw new Error('Unable to load quick view')
              return response.text()
            })
            .then(text => {

              const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view')
              if (!quickViewHTML) throw new Error('Quick view content is missing')

              // create modal w content

              const quickViewContainer = document.createElement('div')
              quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
								class="modal modal--product"
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true"
							>
								<div class="container--medium">
									<div class="modal-content">
										<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`

              this.quickViewModal = quickViewContainer.querySelector('modal-box')
              document.body.appendChild(this.quickViewModal)

              this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML

              if (!window.productPageScripts) {

                const scripts = this.quickViewModal.querySelectorAll('script')
                scripts.forEach(elm => {
                  if (!elm.src) return
                  const script = document.createElement('script')
                  script.src = elm.src
                  script.defer = true
                  document.body.append(script)
                })
                window.productPageScripts = true

              }

              this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', () => {
                this.quickViewModal.hide()
              })

              if (this.quickViewModal.querySelector('[data-js-product-form]')) {
                this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => {
                  this.quickViewModal.hide()
                })
              }

              setTimeout(() => {
                this.quickViewModal.show()
                target.classList.remove('working')
              }, 250)

            })
            .catch(error => {
              console.error(error)
              target.classList.remove('working')
            })

        } else {
          this.quickViewModal.show()
        }

      })
    }
  }

  if (typeof customElements.get('quick-view-product') == 'undefined') {
    customElements.define('quick-view-product', QuickViewProduct)
  }

}

if (typeof VariantSelector !== 'function') {
  class VariantSelector extends HTMLElement {
    constructor() {
      super()
      if (this.querySelector('details')) {
        this.init()
      }
    }
    init() {
      const input = this.querySelector('[name="id"]')
      const details = this.querySelector('details')

      details.addEventListener('click', (event) => {
        const item = event.target.closest('li')
        if (item) {
          if (item.hidden || item.classList.contains('disabled') || item.hasAttribute('disabled')) {
            event.preventDefault()
            return
          }
          const id = item.getAttribute('data-variant-id')
          const label = item.getAttribute('data-variant-label')
          const title = item.getAttribute('data-variant-title')
          this.querySelector('summary [data-variant-title]').textContent = title
          this.querySelector('summary [data-variant-label]').textContent = label

          const items = details.querySelectorAll('ul > li')

          items.forEach(item => {
            item.classList.remove('selected')
          })

          item.classList.add('selected')

          if (input) {
            input.value = id
          }
          details.open = false
          this.dispatchEvent(new CustomEvent('variant-selector:changed', {
            bubbles: true,
            detail: { id }
          }))
        }
      })
      document.addEventListener('click', (event) => {
        if (!details.contains(event.target) && details.open) {
          details.open = false
        }
      })
    }
  }

  if (typeof customElements.get('variant-selector') == 'undefined') {
    customElements.define('variant-selector', VariantSelector)
  }
}

if (typeof WishListButton !== 'function') {
  class WishListButton extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(this.init.bind(this))
    }

    init(swatInstance) {
      this.swat = swatInstance
      window.swat = swatInstance
      this.addButton = this.querySelector('[data-swaction="addToWishlist"]')
      this.removeButton = this.querySelector('[data-swaction="removeFromWishlist"]')
      if (this.removeButton) {
        this.removeButton.addEventListener('click', this.handleRemoveFromWishlist.bind(this))
      }
      this.updateVariant()
    }

    updateVariant() {
      const product = this.closest('.product-item')
      const button = this.querySelector('button')
      if (product) {
        product.addEventListener('variant-selector:changed', (event) => {
          button.setAttribute('data-variant-id', event.detail.id)
          this.swat.initializeActionButtons('body')
        })
      }
    }

    handleRemoveFromWishlist() {
      const epi = this.addButton.dataset.variantId
      this.swat.removeFromWishList({ epi }, (event) => {
        this.addButton.classList.value = 'add-to-wishlist'
        this.swat.initializeActionButtons('body')
      })
    }
  }

  if (typeof customElements.get('wish-list-button') == 'undefined') {
    customElements.define('wish-list-button', WishListButton)
  }
}
